import { cva } from 'class-variance-authority'

import type { ButtonSize } from '@/types/component'

export const BUTTON_SIZE_CLASSES: Partial<Record<ButtonSize, string>> = {
  mini: 'btn-xs',
  small: 'btn-sm',
  medium: 'btn-md',
  large: 'btn-lg',
}

export const BUTTON_SVG_SIZE_CLASSES: Partial<Record<ButtonSize | 'default', string>> = {
  mini: 'size-4',
  small: 'size-5',
  default: 'size-6',
}

const BASE_BUTTON_CLASSES = 'relative ring-inset rounded transition-colors cursor-pointer disabled:cursor-default flex items-center flex-nowrap'

// https://www.figma.com/file/UnOBJd1UtkeEccupL0ZrYs/eatigo-APP?node-id=2283%3A40068&mode=dev
export const buttonVariants = cva(BASE_BUTTON_CLASSES, {
  variants: {
    type: {
      primary: 'text-white bg-red-50 hover:bg-red-60 active:bg-red-80 disabled:[&:not(.btn-loading)]:(bg-red-20 text-gray-10)',
      secondary:
        'text-black-50 bg-white ring-1 ring-gray-50 active:(text-red-50 ring-red-50) disabled:(text-gray-60 ring-gray-60) [&.active]:(text-red-50 ring-red-50)',
      tertiary: 'text-black-50 bg-gray-20 ring-gray-50 disabled:(text-gray-60 ring-gray-60)',
      default: '[&.active]:(text-red-50)',
      ghost: 'text-black-50 bg-transparent hover:bg-gray-20 active:bg-gray-40 disabled:text-gray-60 disabled:bg-transparent',
      text: 'text-black-50 bg-transparent hover:bg-gray-20 active:bg-gray-40 disabled:text-gray-60 disabled:bg-transparent [&.active]:(text-red-50)',
      'primary-text': 'text-red-50 bg-transparent disabled:text-gray-60 disabled:bg-transparent',
      icon: 'bg-transparent hover:bg-gray-20 active:bg-gray-40 disabled:text-gray-60 disabled:bg-transparent',
    },
    size: {
      mini: 'text-sm gap-0.5 px-3 py-0.5',
      small: 'text-base gap-1 px-3 py-1',
      medium: 'text-lg gap-2 px-4 py-2',
      large: 'text-lg gap-2 px-4 py-2',
    },
  },
  compoundVariants: [
    {
      type: 'icon',
      size: 'mini',
      class: 'p-1',
    },
    {
      type: 'icon',
      size: 'small',
      class: 'p-1.5',
    },
    {
      type: 'icon',
      size: 'medium',
      class: 'p-2',
    },
    {
      type: 'icon',
      size: 'large',
      class: 'p-2.5',
    },
  ],
})
